import { useState } from 'react';
import { SwitchCase } from '@toss/react';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { logger } from '@zep/core-logger';
import { BetaChip } from '@/shared/components/Chip/BetaChip';
import { DialogBody, DialogHeader, ResponsiveDialog } from '@/ui_v3';
import { Tabs } from '@/ui_v3/components/tabs';
import { cn } from '@/utils';
import { SearchTabScreen } from './SearchTabScreen';
import { UploadTabScreen } from './UploadTabScreen';
interface ImageUploadModalProps {
  onClose: () => void;
  onUploadStart: (file: File) => void;
  imageUrl?: string;
}
export type ImageUploadTabType = 'upload' | 'search';
export const ImageUploadModal = ({
  onClose,
  onUploadStart,
  imageUrl
}: ImageUploadModalProps) => {
  const [screen, setScreen] = useState<ImageUploadTabType>('upload');
  const {
    t
  } = useTranslation(['build']);
  const handleTabChange = (value: ImageUploadTabType) => {
    if (value === 'search') {
      logger.track('image_search_tab_click');
    }
    setScreen(value);
  };
  return <ResponsiveDialog size={'2xl'} onClose={onClose} shouldCloseOnDimClick={false} data-sentry-element="ResponsiveDialog" data-sentry-component="ImageUploadModal" data-sentry-source-file="ImageUploadModal.tsx">
      <DialogHeader title={t('image.addImage')} hasCloseButton={true} onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="ImageUploadModal.tsx" />
      <DialogBody autoFocus={false} onMouseDown={e => {
      e.stopPropagation();
    }} onClick={e => {
      e.stopPropagation();
    }} className={cn('flex flex-col px-md mobile-lg:px-lg h-[644px] relative', screen === 'upload' && 'pb-lg')} data-sentry-element="DialogBody" data-sentry-source-file="ImageUploadModal.tsx">
        <div className="pb-md">
          <Tabs options={[{
          value: 'upload',
          label: t('image.uploadTab.title')
        }, {
          value: 'search',
          label: <div className="flex items-center gap-3xs">
                    {t('image.searchTab.title')}
                    <BetaChip variant="outlined" className="border-yellow-600 text-yellow-900" />
                  </div>
        }]} isFull={false} size="md" value={screen} onValueChange={handleTabChange} tabTriggerProps={{
          className: 'hover:bg-opacity-black-1 data-[state=inactive]:hover:rounded-xs'
        }} data-sentry-element="Tabs" data-sentry-source-file="ImageUploadModal.tsx" />
        </div>
        <div className="flex-1 overflow-y-auto">
          <SwitchCase value={screen} caseBy={{
          upload: <UploadTabScreen onUploadStart={onUploadStart} imageUrl={imageUrl} />,
          search: <SearchTabScreen onUploadStart={onUploadStart} imageUrl={imageUrl} />
        }} data-sentry-element="SwitchCase" data-sentry-source-file="ImageUploadModal.tsx" />
        </div>
      </DialogBody>
    </ResponsiveDialog>;
};
export const showImageUploadModal = ({
  onUploadStart,
  imageUrl
}: {
  onUploadStart: (file: File) => void;
  imageUrl?: string;
}) => {
  return overlay.open(({
    unmount
  }) => {
    return <ImageUploadModal onClose={unmount} onUploadStart={file => {
      onUploadStart(file);
      unmount();
    }} imageUrl={imageUrl} />;
  });
};